<style lang="scss" scoped>

    #popup-container{
    position:fixed;
    top:0;
    left:0;
    width:100vw;
    height:100%;
    z-index:99999;
    pointer-events: none;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0px;
    padding-bottom: 30px;
    overflow-y: scroll;

    @media (max-height: 700px) {
        align-items: start;
    }

    &.appear{
        pointer-events: all;
        transition: all 600ms;

        .background-obfuscator{
            opacity:1;
            transition: all 600ms;
        }

        .add-address-popup{
            margin-top:70px;

            @media (max-width: 575px) {
                margin-top:20px;
            }

            margin-bottom:20px;
            opacity: 1;
            transition: all 600ms;
            transition-delay: 400ms;
        }

    }

    .add-address-popup{
        position: absolute;
        margin-top:20px;
        width: 90%;
        height:auto;
        display: flex;
        max-width: 400px;
        background: #f1ece5;
        padding:20px;
        opacity:0;

        @media(min-width: 992px) {
            padding:30px 25px;
            max-width: 800px;
        }

    }

    .background-obfuscator{
        position:fixed;
        left:0px;
        top:0;
        width: calc(100%);
        height:100%;
        background:rgba(0, 0, 0, 0.7);
        z-index:-1;
        opacity: 0;
        transition: all 600ms;
    }

    .standalone-close{
        top: 16px;
        right: 12px;
        margin-right: 0;

        @media (max-width: 767px) {
            top: 21px;
        }

        @media (min-width: 992px) {
            top: 15px;
            right: 11px;

            img{
                max-width: 26px !important;
                width: 26px;
            }
        }



    }

}

</style>

<template>
    <div id="popup-container" :class="{'appear' : show}">
        <div class="background-obfuscator" @click="closePopup"></div>

        <div class="add-address-popup">
            <div class="carrello-item__remove-btn standalone-close">
                <a href="javascript:void(0)" @click="closePopup">
                    <img src="/images/svg/as-1.svg" width="22" alt="icona" />
                </a>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12 mb-2">
                        <div class="w-100">
                            <h4 class="azienda-gold-title azienda-gold-title--auth mb-5 text-center">
                                {{$root.translateString(isEditing ? 'edit-address' : 'create-new-address')}}
                            </h4>
                        </div>

                        <div class="checkout-container-row-2__inputs">
                            <div class="full-input">
                                <div class="full-input__field-gr">
                                    <input placeholder=" " type="text" @focus="validation.address.name.state = false" v-model="address.name">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.address.name.state == false}">{{validation.address.name.message}}</div>
                                    <label class="full-input__after-input">
                                        {{$root.translateString('name')}}
                                    </label>
                                </div>
                            </div>
                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input placeholder=" " type="text" @focus="validation.address.phone.state = false" v-model="address.phone">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.address.phone.state == false}">{{validation.address.phone.message}}</div>
                                    <label class="full-input__after-input">
                                        {{$root.translateString('phone')}}
                                    </label>
                                </div>
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input readonly placeholder=" " type="text" :value="lang == 'en' ? 'Italy' : 'Italia'">
                                    <label class="full-input__after-input">
                                        {{$root.translateString('country')}}
                                    </label>
                                </div>
                            </div>
                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input placeholder=" " type="text" @focus="validation.address.address.state = false" v-model="address.address">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.address.address.state == false}">{{validation.address.address.message}}</div>
                                    <label class="full-input__after-input">
                                        {{$root.translateString('address')}}
                                    </label>
                                </div>
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <div class="full-input__field-gr">
                                        <input placeholder=" " type="text" @focus="validation.address.city.state = false" v-model="address.city">
                                        <div class="invalid-feedback" :class="{'d-block' : validation.address.city.state == false}">{{validation.address.city.message}}</div>
                                        <label class="full-input__after-input">
                                            {{$root.translateString('city')}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                                <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                    <v-select
                                        @input="validation.address.province.state = false"
                                        v-model="address.province"
                                        :class="{'full' : (address.province != null && address.province != '')}"
                                        :options="provinces"
                                        label="value"
                                        index="label"
                                        :reduce="label => label.label"
                                    >
                                        <template v-slot:no-options="{ search, searching }">
                                            <template v-if="searching">
                                                <small class="not-found">{{$root.translateString('no_results')}} <strong>{{ search }}</strong></small>
                                            </template>
                                        </template>
                                    </v-select>
                                    <label class="placeholder">
                                        {{$root.translateString('province')}}
                                    </label>
                                    <div class="invalid-feedback" :class="{'d-block' : validation.address.province.state == false}">{{validation.address.province.message}}</div>
                                </div>
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input placeholder=" " type="text" @focus="validation.address.cap.state = false" v-model="address.cap">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.address.cap.state == false}">{{validation.address.cap.message}}</div>
                                    <label class="double-input-select__after-input">
                                        {{$root.translateString('cap')}}
                                    </label>
                                </div>
                            </div>
                            <div class="checkout-container-row-2__checkbox mt-3">
                                <div class="checkbox-styles">
                                    <div class="checkbox">
                                        <input type="checkbox" id="address-def" v-model="address.default">
                                        <label class="d-inline-block w-100" for="address-def"></label>
                                    </div>
                                    <div class="checkbox-styles__link" @click="address.default = !address.default">
                                        {{$root.translateString('make-default-address')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="brand-btn mt-0">
                            <a href="javascript:void(0)" @click="saveAddress" class="full py-2 text-center w-100">
                            <span class="my-1">
                                 {{$root.translateString(isEditing ? 'save-edits': 'create-button')}}
                            </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div class="loader-checkout d-flex align-items-center justify-content-center" v-if="loading">
                <img width="40" src="/images/loader.svg" alt="loader"/>
            </div>
        </transition>

    </div>
</template>
<script>

export default {
    props: ['lang', 'provinces'],
    data() {
        return {
            isEditing: false,
            address: {},
            show: false,
            loading: false,
            validation: {
                address: {
                    name: {
                        state: null,
                        message: '',
                    },
                    address: {
                        state: null,
                        message: '',
                    },
                    city: {
                        state: null,
                        message: '',
                    },
                    cap: {
                        state: null,
                        message: '',
                    },
                    phone: {
                        state: null,
                        message: '',
                    },
                    province: {
                        state: null,
                        message: '',
                    }
                },
            },
        }
    },
    mounted() {

        this.$eventHub.$on('show-address-modal', (payload) => {
            if(payload == null) {
                this.$set(this, 'address', {
                    id: null,
                    name: '',
                    address: '',
                    city: '',
                    cap: '',
                    province: '',
                    phone: '',
                    default: false,
                });

                this.isEditing = false;
            } else {

                this.$set(this.address, 'id', payload.id);
                this.$set(this.address, 'name', payload.name);
                this.$set(this.address, 'address', payload.address);
                this.$set(this.address, 'city', payload.city);
                this.$set(this.address, 'cap', payload.cap);
                this.$set(this.address, 'province', payload.province);
                this.$set(this.address, 'phone', payload.phone);
                this.$set(this.address, 'default', payload.default);

                this.isEditing = true;
            }

            this.openPopup();
        });
    },
    methods: {
        cantProceed() {
            let is_invalid = false;

            Object.keys(this.validation.address).forEach((elem, key) => {
                this.validation.address[elem].message = '';
                this.validation.address[elem].state = null;
            });

            $.each(this.address, (key, elem) => {
                if(elem == '' && typeof this.validation.address[key] != 'undefined') {
                    if (this.lang == 'it') {
                        this.validation.address[key].message = 'Il campo è obbligatorio';
                    } else {
                        this.validation.address[key].message = 'This field is required';
                    }

                    this.validation.address[key].state = false;
                    is_invalid = true;
                }
            });
            return is_invalid;
        },
        saveAddress() {
            if (this.loading) {
                return false;
            } else {
                this.loading = true;
            }

            if(!this.cantProceed()) {
                let payload = this.address;

                // send post request
                axios.post('/api/user/patch-address', this.address).then((response) => {
                    //Check if success == true? else show message?
                    window.location.reload();
                }).catch( e =>  {
                    let errors = e.response.data.errors;
                    this.loading = false;

                    // handle errors
                    for (let error in errors) {
                        this.validation[error].message = errors[error][0];
                        this.validation[error].state = false;
                    }
                });
            }else{
                this.loading = false;
            }

        },
        openPopup() {
            this.show = true;
            document.body.style.top = `-${window.scrollY}px`;
            //document.body.style.position = 'fixed';
            $('body').toggleClass('menu-open');
        },
        closePopup() {
            this.show = false;
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
            $('body').toggleClass('menu-open');
        },
    },
    beforeDestroy() {
        this.$eventHub.$off('show-address-modal');
    },
    computed: {
    }
}
</script>
